import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { ERC20_ABI } from '../contracts/abis';
import web3Provider from '../utils/web3Provider';

export const useTokenBalance = (token, account) => {
  const [balance, setBalance] = useState('0');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchBalance = async () => {
      console.log('🏦 fetchBalance called:', { 
        token: token?.symbol, 
        account, 
        isNative: token?.isNative 
      });
      
      if (!token || !account) {
        console.log('❌ Missing token or account');
        setBalance('0');
        return;
      }

      setLoading(true);
      setError(null);

      try {
        let provider = web3Provider.getProvider();
        console.log('🔗 Wallet provider check:', !!provider);
        
        // If no wallet provider, use public RPC for balance checking
        if (!provider) {
          console.log('⚠️ No wallet provider, using public RPC for balance...');
          try {
            provider = new ethers.JsonRpcProvider('https://rpc.fantom.network');
            console.log('✅ Public provider created for balance check');
          } catch (rpcError) {
            throw new Error('Cannot connect to Fantom network for balance check');
          }
        }

        let balanceWei;

        if (token.isNative) {
          // Native FTM balance
          console.log('💰 Fetching native FTM balance for:', account);
          balanceWei = await provider.getBalance(account);
          console.log('✅ Native balance wei:', balanceWei.toString());
        } else {
          // ERC20 token balance
          console.log('🪙 Fetching ERC20 balance for:', token.address);
          const contract = new ethers.Contract(token.address, ERC20_ABI, provider);
          balanceWei = await contract.balanceOf(account);
          console.log('✅ ERC20 balance wei:', balanceWei.toString());
        }

        if (isMounted) {
          const balanceFormatted = ethers.formatUnits(balanceWei, token.decimals);
          console.log('📊 Balance formatted:', balanceFormatted);
          setBalance(balanceFormatted);
        }
      } catch (err) {
        console.error('Error fetching token balance:', err);
        if (isMounted) {
          setError(err.message);
          setBalance('0');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchBalance();

    // Refresh balance every 10 seconds
    const interval = setInterval(fetchBalance, 10000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [token, account]);

  return { balance, loading, error };
};